import { z } from "zod";
import {
  ADS,
  CONSENT_ENABLED,
  DISPLAY_EMAIL,
  DISPLAY_LANDLINE,
  DISPLAY_MOBILE,
  DISPLAY_NAME,
  NEIGHBOR_PROPERTY_ID,
  OPT_EMERGENCY,
  OPT_GENERAL,
  PARTNER_EMAIL,
  PREFERENCE_ID,
  PROP_ADDRESS,
  PROPERTY_ID,
  SMS_PAST_DUE,
} from "./consts";

export const schema = z.object({
  [PREFERENCE_ID]: z.string().optional(),
  [SMS_PAST_DUE]: z.boolean().optional(),
  [OPT_GENERAL]: z.boolean().optional(),
  [OPT_EMERGENCY]: z.boolean().optional(),
  [DISPLAY_NAME]: z.boolean().optional(),
  [PROP_ADDRESS]: z.boolean().optional(),
  [DISPLAY_EMAIL]: z.boolean().optional(),
  [DISPLAY_MOBILE]: z.boolean().optional(),
  [DISPLAY_LANDLINE]: z.boolean().optional(),
  [ADS]: z.boolean().optional(),
  [PARTNER_EMAIL]: z.boolean().optional(),
  [PROPERTY_ID]: z.string().optional(),
  [NEIGHBOR_PROPERTY_ID]: z.array(z.string()).optional(),
  [CONSENT_ENABLED]: z.boolean().optional(),
});

export type formValues = z.infer<typeof schema>;
